module.exports = __webpack_public_path__ + "img/inq_en.ffd8fc07.svg";